import { type ActionPermissionType } from '../../types';

export function extractToCategoryAndName(id: string) {
  const [category, name] = id.split('.');
  if (!category || !name) {
    throw new Error(`Invalid permission ID ${id} : Both category and name must be provided`);
  }
  return {
    category: category.trim(),
    name: name.trim(),
  };
}

export function extractCategoryAndNameAndAction(id: string) {
  const splittedId = id.split('.') as [string, string];

  if (splittedId.length !== 2) {
    throw new Error(`Invalid permission ID ${id} : Invalid id with category`);
  }

  const [category, nameAndAction] = splittedId;

  const splittedNameAndAction = nameAndAction.split('-') as [string, ActionPermissionType];

  if (splittedId.length !== 2) {
    throw new Error(`Invalid permission ID ${id} : Invalid id with name and action`);
  }

  const [name, action] = splittedNameAndAction;

  return {
    action,
    category,
    name,
  };
}
